import { Redirect } from 'expo-router';
import type { Href } from 'expo-router';
import { ROUTES, FEED_ROUTES } from '@/constants/routes';
import { Platform } from 'react-native';
import { useAuth } from '@/components/providers/AuthProvider';
import { Center } from '@/components/gluestack/center';
import { Spinner } from '@/components/gluestack/spinner';
import { getCommunityFromDomain } from '@/constants/communities';
import { useDefaultFeed } from '@/hooks/useDefaultFeed';

export default function Home() {
  const { isAuthenticated, isLoading, isAuthenticating, currentCommunity } = useAuth();
  const { defaultFeed, isLoaded: isDefaultFeedLoaded } = useDefaultFeed();

  if (isLoading || isAuthenticating || (isAuthenticated && !isDefaultFeedLoaded)) {
    return (
      <Center className="flex-1">
        <Spinner size="large" color="grey" />
      </Center>
    );
  }

  // Decide redirect destination once auth state is known

  if (isAuthenticated) {
    return <Redirect href={FEED_ROUTES[defaultFeed] ?? ROUTES.FEEDS_GLOBAL} />;
  }

  // Must agree with AuthProvider's guard, which also sends signed-out web visitors here to /sign-in
  if (Platform.OS === 'web' && getCommunityFromDomain()) {
    return <Redirect href="/sign-in" />;
  }

  return <Redirect href={'/communities'} />;
}
